import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

import {
    IState
} from "../../utils/state.types";

/**
 * Fetch countries async thunk.
*/
export const fetchStates = createAsyncThunk(
    'state/fetchStates',
    async (): Promise<IState[]> => {
        const response = await axios.get(`/api/v1/states`);
        return response.data.states;
    }
);

